import { render } from "./KubernetesKubectlBasic.vue?vue&type=template&id=16ab499f"
import script from "./KubernetesKubectlBasic.vue?vue&type=script&lang=js"
export * from "./KubernetesKubectlBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__